import "@helmr/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { createServices } from "./app/services";
import { bootKiosk } from "./features/kiosk/boot";
import { supportTokenStore } from "./features/support/boot";

async function boot() {
  let now: (() => number) | undefined;
  // Mocks run in `pnpm dev:mock` only, never in a production build (no fabricated data).
  if (import.meta.env.MODE === "mock") {
    const mock = await import("./test/browser");
    await mock.startMockWorker();
    now = mock.mockNow; // the fixtures describe one fixed morning, so the clock stands still
  }
  // A paired kiosk at /kiosk runs on its own, with no router, shell or staff token (app-kiosk).
  const kiosk = await bootKiosk();
  // A tab opened from the console as a Helmr support session keeps its token in sessionStorage, not the staff login's localStorage.
  const tokenStore = kiosk ? null : supportTokenStore();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      {kiosk ?? <App services={createServices({ now, ...(tokenStore ? { tokenStore } : {}) })} />}
    </StrictMode>,
  );
}

void boot();
